import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from './components/layout/Layout';
import Home from './pages/Home';
import About from './pages/About';
import AppsLayout from './components/apps/AppsLayout';
import AppsPage from './pages/AppsPage';
import AppDetailPage from './pages/AppDetailPage';

function App() {
  return (
    <Router>
      <Routes>
        {/* Main business site — keeps the existing navbar/footer */}
        <Route
          path="/"
          element={
            <Layout>
              <Home />
            </Layout>
          }
        />
        <Route
          path="/about"
          element={
            <Layout>
              <About />
            </Layout>
          }
        />

        {/* App studio — its own header/footer, fully separate */}
        <Route element={<AppsLayout />}>
          <Route path="/apps" element={<AppsPage />} />
          <Route path="/apps/:slug" element={<AppDetailPage />} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
